const isProduction = process.env.NODE_ENV === 'production';

const api = {
  isProduction,
  base: isProduction ? 'https://api.evolvegenius.com' : `//${window.location.hostname}:8090`,
  emmaBase: isProduction ? 'https://evolve-mma.com' : '//evolve-mma.local',
};

export default api;
